import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentPayFromBalance = (state: StateScheme) => {
    return state.payment.payFromBalance
}
